<template>
  <div class="spinner-box-container">
    <div class="spinner-box">
      <pixel-spinner
        :animation-duration="2000"
        :color="colorData"
        :size="120"
      />
    </div>
  </div>
</template>

<script>
import {PixelSpinner } from 'epic-spinners';
export default {
    name: 'Loading',
    components: {
        PixelSpinner
    },
    props: {
        color: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            colorData: null
        };
    },
    created () {
        this.colorData = this.color || (this.$vuetify.theme.isDark) ? this.$vuetify.theme.themes.dark.primary : this.$vuetify.theme.themes.light.primary;
    },
    methods: {

    }
};
</script>

<style scoped>
  .spinner-box-container{
    padding: 10px;
  }
  .pixel-spinner {
    margin: auto;
  }
</style>
